import { defineComponent } from "vue";

export default defineComponent({
  name: "SiteUsers",
  props: {},
  components: {},
  // setup() {},
});
